import { withTransaction } from '@elastic/apm-rum-react';
import { useStateVar } from 'helpers/useStateVar';
import moment from 'moment';
import 'moment/locale/pt-br';
import { apiCall, ApiResps } from 'providers';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';
import { toast } from 'react-toastify';
import { Loader } from '~/components';
import { generateNameFormatted } from '~/helpers/titleHelper';
import { typesUtilitiesExistent } from '../DMTs/AcessorUtilities';
import { IlluminationInfo } from './Illumination/IlluminationInfo';
import {
  Card,
} from './styles';
import { UtilityTypesInfo } from './Utilities/UtilityTypesInfo';
import { UtilityLayout } from './UtilityLayout';
import { colors } from '~/styles/colors';

export const UtilityInfo = (): JSX.Element => {
  const { t } = useTranslation();
  const match = useRouteMatch<{ utilId: string, type: string }>();

  const { type, utilId } = match.params;
  const [state, _, setState] = useStateVar(() => {
    moment.locale('pt-br');
    return {
      selectedIndex: -1 as number,
      utilInfo: null as null|(ApiResps['/dal/get-illumination-info'])|(ApiResps['/dmt/get-utility-info']),
      isLoading: false,
      linkBase: match.url.split(`/${match.params.utilId}`)[0],
    };
  });

  async function getUtilityInfo() {
    try {
      setState({ isLoading: true });
      let utilInfo;
      if (type === 'iluminacao') {
        utilInfo = await apiCall('/dal/get-illumination-info', { UTILITY_ID: Number(utilId) });
      } else if (typesUtilitiesExistent.includes(type)) {
        utilInfo = await apiCall('/dmt/get-utility-info', { UTILITY_ID: Number(utilId) });
      }
      state.utilInfo = utilInfo;
    } catch (err) {
      console.log(err);
      toast.error(t('houveErro'));
    }
    setState({ isLoading: false });
  }

  useEffect(() => {
    getUtilityInfo();
  }, []);

  if (state.isLoading) {
    return (
      <Loader />
    );
  }

  return (
    <>
      <Helmet>
        <title>{generateNameFormatted(state.utilInfo?.NAME, t('perfil'))}</title>
      </Helmet>
      <UtilityLayout key={state.selectedIndex} utilInfo={state.utilInfo} />
      <Card style={{ borderTop: `10px solid ${colors.brand.principal}` }}>
        {type === 'iluminacao' && state.utilInfo && <IlluminationInfo screen="utilityInfo" util={state.utilInfo} /> }
        {typesUtilitiesExistent.includes(type) && state.utilInfo && <UtilityTypesInfo screen="utilityInfo" util={state.utilInfo} type={type} /> }
      </Card>
    </>
  );
};

export default withTransaction('UtilityInfo', 'component')(UtilityInfo);
